export const walletConstant = {
  UDPATE_LOAD_WALLET: "UDPATE_LOAD_WALLET" 
};
